
import { Container, Row, Col } from 'react-bootstrap';
import { AnalyticsHandle } from '../components/AnalyticsHandle';

function Footer() {
    const { logAnalyticsEvent } = AnalyticsHandle();

    const handleFooterClick = (linkName) => {
        logAnalyticsEvent('footer_click', {
            link_name: linkName,
            timestamp: new Date().toISOString()
        });
    }

    return (
        <footer style={{ backgroundColor: '#f8f9fa', padding: '40px 0', marginTop: '60px'}}>
            <Container style={{ maxWidth: '1400px' }}>
                <Row className="mb-4 footer-sections" style={{ gap: '0' }}>
                    {/* Logo i ikony social media */}
                    <Col md={2} className="mb-3 mb-md-0 footer-col footer-col-logo" style={{ borderRight: '1px solid #e5e7eb', paddingRight: '24px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '-4px' }}>
                            <img 
                                src={require('../images/svgs/logo_dark.svg').default} 
                                alt="eGodziny Logo" 
                                style={{ height: '48.4px', marginBottom: '20px' }}
                            />
                            <div style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '30px' }}>
                                <a 
                                    href='mailto:kontakt@egodziny.pl' 
                                    onClick={() => handleFooterClick('email_footer')}
                                    style={{ 
                                        display: 'inline-flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        width: '38px',
                                        height: '38px',
                                        backgroundColor: '#2d6ff4',
                                        color: 'white',
                                        borderRadius: '6px',
                                        textDecoration: 'none'
                                    }}
                                >
                                    <i className="bi bi-envelope-fill" style={{ fontSize: "1.14rem" }}></i>
                                </a>
                                <a 
                                    href="https://www.linkedin.com/company/egodziny/" 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    onClick={() => handleFooterClick('linkedin_footer')}
                                    style={{ 
                                        display: 'inline-flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        width: '38px',
                                        height: '38px',
                                        backgroundColor: '#2d6ff4',
                                        color: 'white',
                                        borderRadius: '6px',
                                        textDecoration: 'none'
                                    }}
                                >
                                    <i className="bi bi-linkedin" style={{ fontSize: "1.14rem" }}></i>
                                </a>
                            </div>
                            <div style={{ color: '#6b7280', fontSize: '0.875rem', lineHeight: '1.6', textAlign: 'center' }}>
                                <div>
                                    <a href="tel:+48515800125" style={{ color: '#6b7280', textDecoration: 'none' }}>
                                        +48 515 800 125
                                    </a>
                                </div>
                                <div>
                                    <a href="mailto:kontakt@egodziny.pl" style={{ color: '#6b7280', textDecoration: 'none' }}>
                                        kontakt@egodziny.pl
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>

                    {/* Produkt */}
                    <Col md={2} className="mb-3 mb-md-0 footer-col" style={{ paddingLeft: '24px', paddingRight: '0px' }}>
                        <h6 style={{ fontWeight: '600', marginBottom: '16px', color: '#1f2937' }}>Produkt</h6>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <a href="/" style={{ color: '#6b7280', textDecoration: 'none', fontSize: '0.875rem' }}>Strona Główna</a>
                            <a href="/funkcje" style={{ color: '#6b7280', textDecoration: 'none', fontSize: '0.875rem' }}>Funkcje</a>
                            <a href="/cennik" style={{ color: '#6b7280', textDecoration: 'none', fontSize: '0.875rem' }}>Cennik</a>
                        </div>
                    </Col>

                    {/* Branże */}
                    <Col md={2} className="mb-3 mb-md-0 footer-col" style={{ paddingLeft: '0px', paddingRight: '0px', marginLeft: '-55px' }}>
                        <h6 style={{ fontWeight: '600', marginBottom: '16px', color: '#1f2937' }}>Branże</h6>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <a href="/praca-tymczasowa-i-outsourcing" onClick={() => handleFooterClick('industry_temp_work_footer')} style={{ color: '#6b7280', textDecoration: 'none', fontSize: '0.875rem' }}>Praca Tymczasowa i Outsourcing</a>
                            <a href="/inzynieria-i-budownictwo" onClick={() => handleFooterClick('industry_engineering_footer')} style={{ color: '#6b7280', textDecoration: 'none', fontSize: '0.875rem' }}>Inżynieria i Budownictwo</a>
                        </div>
                    </Col>

                    {/* Firma */}
                    <Col md={1} className="mb-3 mb-md-0 footer-col" style={{ paddingLeft: '8px' }}>
                        <h6 style={{ fontWeight: '600', marginBottom: '16px', color: '#1f2937' }}>Firma</h6>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <a href="/o-nas" style={{ color: '#6b7280', textDecoration: 'none', fontSize: '0.875rem' }}>O nas</a>
                            <a href="/kontakt" style={{ color: '#6b7280', textDecoration: 'none', fontSize: '0.875rem' }}>Kontakt</a>
                        </div>
                    </Col>

                    {/* Dokumenty */}
                    <Col md={1} className="mb-3 mb-md-0 footer-col footer-col-docs" style={{ borderRight: '1px solid #e5e7eb', paddingRight: '120px' }}>
                        <h6 style={{ fontWeight: '600', marginBottom: '16px', color: '#1f2937' }}>Dokumenty</h6>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <a href="/privacy" style={{ color: '#6b7280', textDecoration: 'none', fontSize: '0.875rem' }}>Polityka prywatności</a>
                            <a href="/regulamin" style={{ color: '#6b7280', textDecoration: 'none', fontSize: '0.875rem' }}>Regulamin</a>
                            <a href="/privacy#cookies" style={{ color: '#6b7280', textDecoration: 'none', fontSize: '0.875rem' }}>Cookies</a>
                        </div>
                    </Col>

                    {/* Adres */}
                    <Col md={2} className="mb-3 mb-md-0 footer-col" style={{ paddingLeft: '36px' }}>
                        <h6 style={{ fontWeight: '600', marginBottom: '16px', color: '#1f2937' }}>Adres</h6>
                        <div style={{ color: '#6b7280', fontSize: '0.875rem', lineHeight: '1.6' }}>
                            <div style={{ fontWeight: '600', marginBottom: '4px' }}>ALTO LABS PSA</div>
                            <div>ul. Lęborska 3B</div>
                            <div>80-386 Gdańsk, Polska</div>
                        </div>
                    </Col>

                    {/* Dane rejestrowe */}
                    <Col md={2} className="mb-3 mb-md-0 footer-col" style={{ paddingLeft: '24px' }}>
                        <h6 style={{ fontWeight: '600', marginBottom: '16px', color: '#1f2937' }}>Dane rejestrowe</h6>
                        <div style={{ color: '#6b7280', fontSize: '0.875rem', lineHeight: '1.6' }}>
                            <div>KRS 0001195670</div>
                            <div>REGON 54281038600000</div>
                            <div>NIP 5842874110</div>
                        </div>
                    </Col>
                </Row>

                <Row className='mt-4' style={{ borderTop: '1px solid #e5e7eb', paddingTop: '20px' }}>
                    <Col className="text-center">
                        <p style={{ fontSize: '0.875rem', color: '#9ca3af', marginBottom: '0' }}>
                            © 2026 eGodziny. Wszelkie prawa zastrzeżone.
                        </p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
}

export default Footer;
